import type { FC } from "react";
import {
	ClientPortfolioInvestmentFrequencyEnum,
	ClientPortfolioToolTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	ToolKind,
	ToolRowCommonProps,
} from "web_myplann/Portfolio/Helpers/investmentToolTypes";
import { useToolSummary } from "web_myplann/Portfolio/Helpers/useToolSummary";
import { DataRow } from "web_myplann/Shared/Components/DataRow";
import { numberFormatter } from "web_myplann/Shared/Utils/numberFormatters";
import { EMPTY_DETAIL_FIELD } from "web_myplann/Utils/constants";
import { ToolRowWrapper } from "./ToolRowWrapper";

const PageResources = Resources.PortfolioDetail;

export const BankProductToolRow: FC<
	ToolRowCommonProps<typeof ToolKind.BankProduct>
> = ({ tool, portfolioId, toolsSummary, expanded, onToggle, noDivider }) => {
	const { t } = useResource();
	const { totalValue, totalInvested } = useToolSummary(tool.id, toolsSummary);

	const getRecurringValue = () => {
		if (tool.monthlyPayment <= 0) {
			return EMPTY_DETAIL_FIELD;
		}

		const frequency = t(
			PageResources.ToolHistory.Fund.Frequency[
				ClientPortfolioInvestmentFrequencyEnum.Monthly
			],
		).toLowerCase();
		const formattedAmount = numberFormatter.format(
			Math.round(tool.monthlyPayment),
		);

		return `${formattedAmount} ${t(Resources.Common.CurrencySign)} ${frequency}`;
	};

	return (
		<ToolRowWrapper
			label={tool.name ?? ""}
			totalValue={totalValue}
			expanded={expanded}
			onToggle={onToggle}
			noDivider={noDivider}
			portfolioId={portfolioId}
			historyTarget={{ toolId: tool.id }}
		>
			<DataRow
				label={t(PageResources.LifeInsurance.InvestmentTool.type)}
				value={t(
					PageResources.LifeInsurance.InvestmentTool.Type[
						tool.type ?? ClientPortfolioToolTypeEnum.Other
					],
				)}
			/>
			<DataRow
				label={t(PageResources.SharedLabels.recurringPayment)}
				value={getRecurringValue()}
			/>
			<DataRow
				label={t(PageResources.SharedLabels.investedAll)}
				value={totalInvested}
			/>
			<DataRow
				label={t(PageResources.SharedLabels.currentValue)}
				value={totalValue}
			/>
		</ToolRowWrapper>
	);
};
